import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss']
})

export class ForgotPasswordPageComponent implements OnInit, AfterViewInit {
  public form: FormGroup;
  public loading = false;
  public errorMessage?: string;
  public attemptedSubmit = false;
  public successfullySent = false;
  public captchaVisibleAnimation = false;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const email = this.route.snapshot.paramMap.get('email');
    this.form = new FormGroup({
      email: new FormControl(typeof email === 'string' && email.length > 0 ? email : '', [Validators.required]),
      token: new FormControl('', [Validators.required])
    });
  }

  ngAfterViewInit() {
    setTimeout(() => this.captchaVisibleAnimation = true, 100);
  }

  get email(): FormControl { return this.form.get('email') as FormControl; }
  get token(): FormControl { return this.form.get('token') as FormControl; }

  onCaptchaResolved(captchaResponse: string) {
    this.token.setErrors(captchaResponse === '' ? {required: true} : null);
    this.token.setValue(captchaResponse);
    this.token.markAsDirty();
    this.token.markAsTouched();
  }

  async onSubmitClick() {
    this.errorMessage = '';
    this.attemptedSubmit = true;
    if (this.form.invalid) {
      if (!this.form.dirty) {
        this.form.markAsDirty();
      }
      return;
    }
    if (this.successfullySent) {
      return;
    }
    const email = this.email.value;
    const token = this.token.value;
    this.loading = true;
    try {
      const response = await this.loginService.forgotPassword(email, token);
      if (response === true) {
        this.successfullySent = true;
      } else {
        console.log(response);
        this.errorMessage = "Unexpected server response";
      }
    } catch(err) {
      if (typeof err.message === "string" && err.message.length > 0) {
        this.errorMessage = err.message;
      } else {
        console.log(err);
        this.errorMessage = 'Unknown component error';
      }
    }
    this.loading = false;
  }

}
